import React, { useEffect, useState } from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { fetchExerciseByCourseIdAsync } from 'store/actions';
import { baseURLs } from 'utils/baseURLs';
import { useDispatch } from 'react-redux';
import moodleAxios from '../../services/moodle/moodleApi';
import { jwtDecode } from 'jwt-decode';

const PreviewPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate(); // Initialize navigate
  const dispatch = useDispatch();

  useEffect(() => {
    // CKey-112: Reroute session through index page
    /*const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const decoded = jwtDecode(token);
    const { userId, username, userEmail, activityInstance, activityID } = {
      userId: decoded?.userid,
      username: decoded?.username,
      userEmail: decoded?.email,
      activityInstance: decoded?.course,
      activityID: decoded?.instance
    };

    // Clear existing localStorage and sessionStorage values
    localStorage.clear();
    sessionStorage.clear();

    // Store new values in localStorage
    localStorage.setItem('userid', userId);
    localStorage.setItem('username', username);
    localStorage.setItem('userEmail', userEmail);
    localStorage.setItem('activityID', activityID);
    localStorage.setItem('courseIdselected', activityInstance);

    // Store activityInstance and other values in sessionStorage
    sessionStorage.setItem('activityInstance', activityInstance);
    sessionStorage.setItem('userid', userId);
    sessionStorage.setItem('username', username);
    sessionStorage.setItem('userEmail', userEmail);
    sessionStorage.setItem('activityID', activityID);*/
    const activityInstance = sessionStorage.getItem("activityInstance");
    const activityID  =   sessionStorage.getItem("activityID");

    // Fetch exercises
    fetchExercises(activityInstance, activityID);
  }, []);

  //   let index = links.links.findIndex(x => x.id == sessionStorage.getItem('activityID'));
  // Fetch exercise data based on courseId (or activityInstance in this case)
  const fetchExercises = async (activityInstance, activityID) => {
    if (activityInstance !== 'T1234') {
      setIsLoading(true);

      try {
        let exercise = await dispatch(
          fetchExerciseByCourseIdAsync(baseURLs.core_course_get_contents + activityInstance +'&options[0][name]=modname&options[0][value]=kb')
        ).unwrap(); // Unwraps the promise returned by dispatch

        //Filter out empty topics
        exercise = exercise.filter(item => item.modules.length > 0);
        // setExerciseData(exercise);
        //setExercise(localStorage.getItem('exercises'));
        // console.log(exercise);

        // SJK: CKey-85 : Append userid to Moodle API
        const res = await moodleAxios.get(baseURLs.Service_for_KB_data + activityID + "&userid=" + localStorage.getItem('userid'));

        // After fetching the exercise data, navigate to the courses page
        const replaced = val => {
          if (val === undefined) {
            return val;
          } else {
            val = val.toString()?.replace(/\//g, '');
            val = val.toString()?.replace(/\?/g, '');
            return val.toString()?.replace(/ /g, '_');
          }
        };

        // Find the index.
        const parentIndex = exercise.findIndex(item =>
          item.modules.some(module => module.instance == activityID)
        );
        const filteredData = exercise[parentIndex].modules.map(({ instance, name, visible }) => ({
          id: instance,
          name,
          visible
        }));
        const activity = res.data.Activities.Activity;
        const formattedTitle = replaced(activity.Label) + replaced(activity.Title);
        let link = '';
        if (formattedTitle?.split('_').includes('Document')) {
          link = `/courses/editor/${replaced(formattedTitle)}-${replaced(activityID)}`;
        } else {
          link = `/courses/typing/${replaced(formattedTitle)}-${replaced(activityID)}`;
        }
        const currentCourseId = exercise[parentIndex].id;
        const pathnameForNext = `/courses/courses/${currentCourseId}`;
        sessionStorage.setItem('pathnameForNext', pathnameForNext);
        navigate(`${link}`, {
          state: {
            links: filteredData,
            courseID: activityInstance
          }
        }); // Redirect to the courses page
      } catch (error) {
        console.error('Error fetching exercises:', error);
      }

      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
      {isLoading ? (
        // Loading Spinner
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Loading...</Typography>
        </Box>
      ) : (
        // Render a simple message or nothing when not loading
        <Typography variant="h6">Redirecting to courses...</Typography>
      )}
    </Box>
  );
};

export default PreviewPage;
